/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';

import { ISecurityQuestionAnswer } from 'src/interfaces';
import { ResetPasswordEmailForm } from './email-form';
import { ResetPasswordSecurityQuestionAnswerForm } from './questions-form';

export const ResetPasswordModal: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const [email, setEmail] = useState<string>('');
  const [securityQuestionAnswer, setSecurityQuestionAnswer] = useState<ISecurityQuestionAnswer[]>([]);

  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);
  const [modalState, setModalState] = useState<number>(1);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setModalState(1);
  }, [modalIsOpen]);

  const handleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  const handleModalState = (state: number) => {
    setModalState(++state);
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: 'max-content',
          maxWidth: '600px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
    >
      {modalState === 1 ? (
        <ResetPasswordEmailForm
          handleModal={handleModal}
          handleModalState={handleModalState}
          setSecurityQuestionAnswer={setSecurityQuestionAnswer}
          setEmail={setEmail}
        />
      ) : (
        <ResetPasswordSecurityQuestionAnswerForm
          handleModal={handleModal}
          handleModalState={handleModalState}
          securityQuestionAnswer={securityQuestionAnswer}
          email={email}
        />
      )}
    </ReactModal>
  );
};
